const createLsHelper = (key, defaultValue) => ({
    get: () => {
        const isOpen = localStorage.getItem(key);
        return isOpen === null ? defaultValue : JSON.parse(isOpen);
    },
    set: isOpen => localStorage.setItem(key, isOpen),
});

export default createLsHelper;



// WEBPACK FOOTER //
// ./lib/js/modules/odds/helpers/createLsHelper.js